import { Flex } from "antd";
import { FC } from "react";
import { Point, TaskPromoTagPhotos } from "tm-shared/types";
import { formatUAHStandard } from "tm-shared/utils";

import { useCatalog } from "@/domains/product";
import {
    CustomTaskFromTaskButton,
    SubtaskCard,
    TaskViewModal,
} from "@/features/TaskView/components";
import { PrimaryText, SecondaryText } from "@/shared/ui";

interface PromoTagPhotosViewModalProps {
    task: TaskPromoTagPhotos;
    point: Point;
    onClose: () => void;
}

export const PromoTagPhotosViewModal: FC<PromoTagPhotosViewModalProps> = ({
    task,
    point,
    onClose,
}) => {
    const { products } = useCatalog();
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const subtasks = task.context.products;
    const taskImages = Object.values(taskPayload).flatMap(
        ({ photos }) => photos ?? [],
    );

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    point={point}
                    images={taskImages}
                />
                {subtasks.map(({ barcode, price }) => {
                    const subtaskPayload = taskPayload[barcode];
                    const title = products?.[barcode]?.name ?? barcode;

                    if (!subtaskPayload) return null;

                    return (
                        <SubtaskCard
                            key={barcode}
                            subtask={subtaskPayload}
                            title={title}
                            details={
                                subtaskPayload.performerValue && (
                                    <Flex vertical>
                                        <Flex gap={8}>
                                            <SecondaryText>
                                                Акційна ціна:
                                            </SecondaryText>

                                            <PrimaryText>
                                                {formatUAHStandard(+price)}
                                            </PrimaryText>
                                        </Flex>

                                        <Flex gap={8}>
                                            <SecondaryText>
                                                Фактична ціна:
                                            </SecondaryText>

                                            <PrimaryText>
                                                {formatUAHStandard(
                                                    subtaskPayload.performerValue,
                                                )}
                                            </PrimaryText>
                                        </Flex>
                                    </Flex>
                                )
                            }
                        />
                    );
                })}
            </Flex>
        </TaskViewModal>
    );
};
